var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 926,
    height: 911,
    viewBox: "0 0 926 911",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921.672 625.764C890.921 795.463 611.168 903.877 408.705 910.825C345.18 913.005 290.008 876.21 239.681 837.385C-2.17769 650.801 -249.071 840.828 -66.7512 357.022C-33.0627 171.114 61.3675 -24.2066 276.724 59.6835C307.673 71.7396 342.989 69.7511 371.712 53.0717C773.414 -180.196 956.529 433.411 921.672 625.764Z",
    fill: "url(#paint0_linear_1792_486)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1792_486",
    x1: 506.859,
    y1: -9.84815,
    x2: 340.142,
    y2: 910.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB0B0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpbg);
export default __webpack_public_path__ + "static/media/empbg.40bdbe8bc1ef4050d4c51a235d2f64dc.svg";
export { ForwardRef as ReactComponent };